module.exports = __webpack_public_path__ + "images/般蓝pr长图06-4_02.jpg?v=f8552da2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图06-4_02.jpg
 ** module id = 176
 ** module chunks = 1 2
 **/